// A parte pura de uma planta: onde dá para pisar e os pontos de uso que os móveis
// oferecem. Sem DOM — o layout, a busca de caminho e os testes usam isto em Node.

import { mapSize, type Placement, type RoomMap, type Spot } from '../../core/world.js';
import { FURNITURE_BY_ID } from '../art/furniture/index.js';
import type { FurnitureDef, FurnitureSpot } from '../art/types.js';

export interface RoomData {
  w: number;
  h: number;
  /** walkable[y][x]: dá para pisar no tile? */
  walkable: boolean[][];
  /** Pontos de uso (dos móveis + os extras da planta), em tiles da sala. */
  spots: Spot[];
}

const cache = new WeakMap<RoomMap, RoomData>();

/** Tile da sala onde fica o ponto de um móvel colocado (espelhado em x se o móvel estiver virado). */
export function spotTile(def: FurnitureDef, placement: Placement, s: FurnitureSpot): { x: number; y: number } {
  const dx = placement.flip ? def.footprint.w - 1 - s.dx : s.dx;
  return { x: placement.x + dx, y: placement.y + s.dy };
}

export function roomData(map: RoomMap): RoomData {
  const hit = cache.get(map);
  if (hit) return hit;
  const { w, h } = mapSize(map);
  const inside = (x: number, y: number) => (map.floor[y]?.[x] ?? ' ') !== ' ';
  const walkable = Array.from({ length: h }, (_, y) => Array.from({ length: w }, (_, x) => inside(x, y)));
  const spots: Spot[] = [...(map.spots ?? [])];
  map.items.forEach((placement, index) => {
    const def = FURNITURE_BY_ID.get(placement.item);
    if (!def || def.wall) return;
    if (def.blocks !== false) {
      for (let j = 0; j < def.footprint.h; j++) {
        for (let i = 0; i < def.footprint.w; i++) {
          const row = walkable[placement.y + j];
          if (row && placement.x + i < row.length) row[placement.x + i] = false;
        }
      }
    }
    for (const [k, s] of (def.spots ?? []).entries()) {
      const tile = spotTile(def, placement, s);
      const facing = placement.flip && (s.facing === 'left' || s.facing === 'right') ? (s.facing === 'left' ? 'right' : 'left') : s.facing;
      spots.push({ id: `${map.id}:${index}:${k}`, x: tile.x, y: tile.y, facing, kind: s.kind, use: s.use });
    }
  });
  const data = { w, h, walkable, spots };
  cache.set(map, data);
  return data;
}
